module.exports = __webpack_public_path__ + "static/media/scary_4.b0526fb0.jpg";